"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmitterTypeToEnum = exports.getValueTypeFromEmitterType = exports.getEmitterTypeFromValueType = exports.IRRIGATION_ACTIVITY_PLANNED_VALUE_TYPE_PREFIX = exports.IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX = exports.IRRIGATION_EXTERNAL_PLANNED_INTERVALS_VALUE_TYPE_PREFIX = exports.IRRIGATION_EXTERNAL_APPLIED_INTERVALS_VALUE_TYPE_PREFIX = exports.IRRIGATION_EXTERNAL_PLANNED_VOLUME_VALUE_TYPE_PREFIX = exports.IRRIGATION_EXTERNAL_APPLIED_VOLUME_VALUE_TYPE_PREFIX = exports.IRRIGATION_PLANNED_VOLUME_VALUE_TYPE_PREFIX = exports.IRRIGATION_APPLIED_VOLUME_VALUE_TYPE_PREFIX = exports.IRRIGATION_PRESSURE_VALUE_TYPE_PREFIX = exports.EMITTER_TYPES = void 0;
exports.EMITTER_TYPES = [
    'emitter-buried-drip-1',
    'emitter-buried-drip-2',
    'emitter-drip-1',
    'emitter-drip-2',
    'emitter-microspray',
    'emitter-sprinkler',
    'emitter-flood-furrow',
    'emitter-overhead-cooling-microspray',
    'emitter-overhead-cooling-sprinkler',
    'emitter-other',
    'pump',
];
exports.IRRIGATION_PRESSURE_VALUE_TYPE_PREFIX = 'irrigationPressureSemios_';
exports.IRRIGATION_APPLIED_VOLUME_VALUE_TYPE_PREFIX = 'irrigationVolumeDurationSemios_';
exports.IRRIGATION_PLANNED_VOLUME_VALUE_TYPE_PREFIX = 'irrigationPlannedVolumeDurationSemios_';
exports.IRRIGATION_EXTERNAL_APPLIED_VOLUME_VALUE_TYPE_PREFIX = 'irrigationAppliedVolumeDurationExternal_';
exports.IRRIGATION_EXTERNAL_PLANNED_VOLUME_VALUE_TYPE_PREFIX = 'irrigationPlannedVolumeDurationExternal_';
exports.IRRIGATION_EXTERNAL_APPLIED_INTERVALS_VALUE_TYPE_PREFIX = 'irrigationAppliedIntervalsExternal_';
exports.IRRIGATION_EXTERNAL_PLANNED_INTERVALS_VALUE_TYPE_PREFIX = 'irrigationPlannedIntervalsExternal_';
exports.IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX = 'irrigationActivityIntervalsSemios_';
exports.IRRIGATION_ACTIVITY_PLANNED_VALUE_TYPE_PREFIX = 'irrigationActivityPlannedIntervalsSemios_';
const valueTypeSuffixToEnum = {
    'emitter-buried-drip-1': 'emitterBuriedDrip1',
    'emitter-buried-drip-2': 'emitterBuriedDrip2',
    'emitter-drip-1': 'emitterDrip1',
    'emitter-drip-2': 'emitterDrip2',
    'emitter-flood-furrow': 'emitterFloodFurrow',
    'emitter-microspray': 'emitterMicrospray',
    'emitter-other': 'emitterOther',
    'emitter-overhead-cooling-microspray': 'emitterOverheadCoolingMicrospray',
    'emitter-overhead-cooling-sprinkler': 'emitterOverheadCoolingSprinkler',
    'emitter-sprinkler': 'emitterSprinkler',
    'pump': 'pump',
};
const getEmitterTypeFromValueType = (valueType) => {
    const kebabCasedEmitter = valueType
        ?.match(/(?:_emitte|_pum)([^_]+)_/)?.[0]
        ?.replace(/_/g, '')
        ?.replace(/([a-z])([A-Z0-9])/g, '$1-$2')
        ?.toLowerCase();
    // if (kebabCasedEmitter && kebabCasedEmitter in valueTypeSuffixToEnum)
    return kebabCasedEmitter;
    // return null
};
exports.getEmitterTypeFromValueType = getEmitterTypeFromValueType;
const getValueTypeFromEmitterType = (valueTypePrefix, emitterType) => {
    const suffix = valueTypeSuffixToEnum[emitterType];
    return valueTypePrefix + suffix;
};
exports.getValueTypeFromEmitterType = getValueTypeFromEmitterType;
const getEmitterTypeToEnum = (emitterType) => valueTypeSuffixToEnum[emitterType];
exports.getEmitterTypeToEnum = getEmitterTypeToEnum;
//# sourceMappingURL=emitterTypeToValueTypeMapper.js.map